@if (setting().isDisabled) {
  <aw-tooltip
    [text]="cmsTextProvider.configuration.unavailableForProduct"
    [hoverDelayMs]="tooltipHoverDelayMs"
    [showIcon]="false">
    <span
      tabindex="0"
      class="material-symbols-rounded text-standard-text-secondary cursor-not-allowed"
      [attr.aria-label]="cmsTextProvider.configuration.unavailableForProduct">
      block
    </span>
  </aw-tooltip>
} @else {
  @switch (setting().inputType) {
    @case (inputType.Custom) {
      <aw-configuration-custom-input
        class="block w-full"
        [setting]="setting()"
        [inputId]="inputId()"
        [control]="control()" />
    }
    @case (inputType.Checkbox) {
      <aw-toggle
        class="w-auto"
        [id]="inputId()"
        [label]="''"
        [formControl]="control()" />
    }
    @case (inputType.NumberField) {
      <aw-number-input
        class="block w-full"
        [id]="inputId()"
        [formControl]="control()" />
    }
    @case (inputType.SingleSelect) {
      @if (selectOptions().length <= 3) {
        <aw-button-group
          class="block w-full"
          [id]="inputId()"
          [options]="buttonOptions()"
          [buttonsPerRow]="selectOptions().length"
          [formControl]="control()" />
      } @else {
        <aw-drop-down
          class="block w-full"
          [id]="inputId()"
          [searchable]="selectOptions().length > 7"
          [showClearOption]="true"
          [options]="selectOptions()"
          [formControl]="control()" />
      }
    }
    @case (inputType.Icon) {
      <aw-icon-picker
        class="block w-full"
        [id]="inputId()"
        [formControl]="control()" />
    }
    @case (inputType.MultiSelect) {
      @if (selectOptions().length <= 3) {
        <div class="flex w-full flex-wrap justify-center gap-2">
          @for (option of selectOptions(); track option) {
            <button type="button" (click)="toggleMultiSelectOption(option)">
              <aw-toggle-chip
                [text]="option"
                [isChecked]="isMultiSelectOptionSelected(option)" />
            </button>
          }
        </div>
      } @else {
        <aw-multi-select-drop-down
          class="block w-full"
          [id]="inputId()"
          [searchable]="selectOptions().length > 7"
          [options]="selectOptions()"
          [formControl]="control()" />
      }
    }
    @default {
      <aw-text-input
        class="block w-full"
        [id]="inputId()"
        [formControl]="control()" />
    }
  }
}
